module.exports = __webpack_public_path__ + "img/7.4-gallery.39d125be.jpg";